import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConveyor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 60,
	viewBox: "0 0 200.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 200,
		height: 60,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 20.0 30.0 L 115.0 30.0 M 115.0 20.0 L 115.0 40.0 L 150.0 30.0 Z",
		fill: "#000000",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgConveyor;
